import { useFormInput } from '../../../../shared/FormInput';
import { PERSONAL_FIELDS } from '../../../constants';
import { isEmailAvailable, STATUS } from '../../services/emailAvailability';

const EMAIL_REGEX =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const EMAIL_VALIDATION = {
    REGEXP: 'regexp',
};

const emailValidation = async (email) => {
    if (!email.match(EMAIL_REGEX)) {
        return [false, EMAIL_VALIDATION.REGEXP];
    }

    const status = await isEmailAvailable(email);

    return [status === STATUS.FREE, status];
};

export const useEmailField = (value, onFieldInteracted) =>
    useFormInput({
        name: PERSONAL_FIELDS.EMAIL,
        initialValue: value,
        onFieldInteracted,
        validationFunc: emailValidation,
    });
